/** Bulle « en train d’écrire » avec points animés */
export function TypingIndicator({ label }: { label?: string | null }) {
  return (
    <div className="chat-typing-row flex items-end gap-2" aria-live="polite">
      <div className="chat-typing-bubble chat-bubble-other inline-flex items-center gap-1 rounded-xl rounded-bl-sm px-2.5 py-1.5 shadow-sm">
        <span className="chat-typing-dot" />
        <span className="chat-typing-dot" />
        <span className="chat-typing-dot" />
      </div>
      {label ? (
        <span className="pb-1 text-[11px] text-[var(--chat-muted)]">{label}</span>
      ) : null}
    </div>
  );
}
